import { render, staticRenderFns } from "./SRT.vue?vue&type=template&id=3a34c1e4&scoped=true&"
import script from "./SRT.vue?vue&type=script&lang=ts&"
export * from "./SRT.vue?vue&type=script&lang=ts&"
import style0 from "./SRT.vue?vue&type=style&index=0&id=3a34c1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a34c1e4",
  null
  
)

export default component.exports